export default "https://cdn-static.gokick.com/assets/ac547ee441cd23ce845c1e2810a666ddd08d044b/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";